<style>
    .btns {
        text-align: center;
        margin: 30% auto;
        padding: 20px;
        box-shadow: 10px 5px 5px lightgrey;
        width: 300px;
    }

    .quizbtn {

    }

</style>
<template>
    <main>
        <div class="btns" v-if="!quizOfToday.quizs || quizOfToday.quizs.length === 0">
            퀴즈를 선택 하시오.<br>
            <button class="btn btn-primary quizbtn" @click="fetchQuiz('remon')" :disabled="fetchingQuiz">RemonBank</button>
            <button class="btn btn-primary quizbtn" @click="fetchQuiz('tomato')" :disabled="fetchingQuiz">Dummy</button>
            <br>
            <span v-if="fetchingQuiz">퀴즈를 불러 오는 중 입니다</span>
        </div>
        <ul class="list-unstyled">
          <li
            v-for="(q, i) in quizOfToday.quizs"
            :key="i">
            <quizzes-item
              :quiz="q"
              :number="i+1"></quizzes-item>
          </li>
        </ul>
    </main>
</template>

<script>
import { mapState } from 'vuex'
// import l from '@/vendor/logger'
import QuizzesItem from './QuizzesItem'

export default {
  name: 'Quizzes',
  data () {
    return {
      fetchingQuiz: false
    }
  },
  computed: {
    ...mapState('quizzes', [
      'quizOfToday',
      'quizHistory'
    ])
  },
  methods: {
    fetchQuiz (lo) {
      this.fetchingQuiz = true
      this.$store.dispatch('quizzes/fetchQuizzes', lo)
    }
  },
  watch: {
    quizOfToday () {
      if (!this.quizOfToday.quizs || this.quizOfToday.quizs.length === 0) {
        this.fetchingQuiz = false
      } else {
        this.fetchingQuiz = true
      }
    }
  },
  components: {
    QuizzesItem
  }
}
</script>

<style scoped>

</style>
